import axios from "axios";

export const state = {
    reportpaymentsbyuser: [],
};

export const getters = {
    reportpaymentsbyuser: state => state.reportpaymentsbyuser,
};

export const mutations = {
    setReportPaymentsbyUser(reportpaymentsbyuser, newValue) { state.reportpaymentsbyuser = newValue},
};

export const actions = {
    fetchReportPaymentsbyUser({ commit }) {
        axios.get('/reportpaymentsbyuser').then(res => {
            commit('setReportPaymentsbyUser', res.data.payments)
        })
    },
    filterReportPaymentsbyUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpaymentsbyuser";
        axios.post(url, formData).then((response) => {
            commit('setReportPaymentsbyUser', response.data.payments)
        })
    },
};
